import React, { useState, useEffect } from 'react'
import MenuSection from './MenuSection'
import MenuTable from './MenuTable'
import { menuSections, tableConfigs, generateTransactionData } from './dummyData'
import styles from './dummyMenu.module.scss'

const DummyMenu = () => {
  const [activeSections, setActiveSections] = useState({})
  const [tableData, setTableData] = useState({})
  const [showTables, setShowTables] = useState({})
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  // Initialize active sections and generate table data
  useEffect(() => {
    try {
      setLoading(true)
      
      const initialActiveSections = {}
      menuSections.forEach(section => {
        initialActiveSections[section.id] = section.defaultExpanded
      })
      setActiveSections(initialActiveSections)

      // Simulate async data loading
      setTimeout(() => {
        try {
          setTableData({
            dttot: generateTransactionData(15),
            transaksiKhusus: generateTransactionData(12)
          })
          setLoading(false)
        } catch (err) {
          setError('Failed to generate table data')
          setLoading(false)
        }
      }, 500)
      
    } catch (err) {
      setError('Failed to initialize menu')
      setLoading(false)
    }
  }, [])

  const toggleSection = (sectionId) => {
    setActiveSections(prev => ({
      ...prev,
      [sectionId]: !prev[sectionId]
    }))
  }

  const handleItemClick = (item) => {
    if (item.type === 'table') {
      setShowTables(prev => ({
        ...prev,
        [item.id]: !prev[item.id]
      }))
    }
  }

  // Error boundary fallback
  if (error) {
    return (
      <div className={styles.menuContainer}>
        <div className={styles.emptyState}>
          <div className={styles.emptyIcon}>⚠️</div>
          <div className={styles.emptyText}>Something went wrong</div>
          <div className={styles.emptySubtext}>{error}</div>
        </div>
      </div>
    )
  }

  // Loading state
  if (loading) {
    return (
      <div className={styles.menuContainer}>
        <div className={styles.loadingState}>
          Loading menu data...
        </div>
      </div>
    )
  }

  return (
    <div className={styles.menuContainer}>
      {/* Render menu sections */}
      {menuSections.map(section => (
        <MenuSection
          key={section.id}
          title={section.title}
          items={section.items}
          isActive={activeSections[section.id]}
          onToggle={() => toggleSection(section.id)}
          onItemClick={handleItemClick}
        />
      ))}

      {/* Always render DTTOT table */}
      <MenuTable
        title={tableConfigs.dttot.title}
        description={tableConfigs.dttot.description}
        columns={tableConfigs.dttot.columns}
        data={tableData.dttot || []}
        showSortDaily={tableConfigs.dttot.showSortDaily}
      />

      {/* Always render Special Transactions table */}
      <MenuTable
        title={tableConfigs.transaksiKhusus.title}
        description={tableConfigs.transaksiKhusus.description}
        columns={tableConfigs.transaksiKhusus.columns}
        data={tableData.transaksiKhusus || []}
        showSortDaily={tableConfigs.transaksiKhusus.showSortDaily}
      />
    </div>
  )
}

export default DummyMenu